import { render, staticRenderFns } from "./buyerList.vue?vue&type=template&id=2ad8af33&scoped=true&"
import script from "./buyerList.vue?vue&type=script&lang=js&"
export * from "./buyerList.vue?vue&type=script&lang=js&"
import style0 from "./buyerList.vue?vue&type=style&index=0&id=2ad8af33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad8af33",
  null
  
)

export default component.exports